import { fromJS } from 'immutable';

export default fromJS({
    isMemberTransferPopupOpen: false,
    membersTransferResult: []
});